exports.list = {
    path: '/laporan_pengeluaran_consumable',
    name: 'laporan_pengeluaran_consumable_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_pengeluaran_consumable/List.vue"),
}